<template>
  <v-container class="form-container rounded-lg">
    <h1>New speciality</h1>
    <CreateForm :fields="fields" name="specialities" />
  </v-container>
</template>

<script>
import { markRaw } from "vue";
import CreateForm from "@/Admin/components/CreateForm.vue";
import TextField from "@/Admin/components/form/TextField.vue";

import {ruleSet, ruleSetGen} from "@/Admin/helpers/rules";
import SelectField from "@/Admin/components/form/SelectField.vue";
import config from "@/helpers/api";
import ImagePickField from "@/Admin/components/form/ImagePickField.vue";
import TextEditorField from "@/Admin/components/form/TextEditorField.vue";
export default {
  name: "SpecialityCreateView",
  components: { CreateForm },
  data() {
    return {
      fields: {
        banner_url: {
          component: markRaw(ImagePickField),
          data: {
            label: "Select image",
            name: "banner_url",
            size: 700,
            rules: ruleSet.image,
          },
        },
        name: {
          component: markRaw(TextField),
          data: {
            label: "Name",
            placeholder: "Enter speciality name",
            name: "name",
            rules: ruleSetGen.text("Enter correct speciality name", true, 3),
          },
        },
        department_id: {
          component: markRaw(SelectField),
          data: {
            label: "Department",
            placeholder: "Select department",
            name: "department_id",
            items: [],
            itemTitle: "name",
            itemValue: "id",
          },
        },
        keywords: {
          component: markRaw(SelectField),
          data: {
            label: "Key words",
            placeholder: "Select key words",
            name: "keywords",
            items: [],
            multiple: true,
            itemTitle: "text",
            itemValue: "id",
          },
        },
        text: {
          component: markRaw(TextEditorField),
          data: {
            label: "Description",
            placeholder: "Enter description",
            name: "text",
            rules: ruleSetGen.text("Enter correct speciality description", true, 3),
          },
        },
        school_description: {
          component: markRaw(TextEditorField),
          data: {
            label: "Career opportunities",
            placeholder: "Enter career opportunities",
            name: "school_description",
            rules: ruleSetGen.text("Enter correct school description", true, 3),
          },
        },
      },
    };
  },
  async created() {
    await fetch(`${config.baseURL}/departments`, {
      method: "GET",
      headers: config.headers,
    })
      .then((response) => response.json())
      .then((response) => {
        this.fields.department_id.data.items = response.data;
      });

    await fetch(`${config.baseURL}/keyWords`, {
      method: "GET",
      headers: config.headers,
    })
      .then((response) => response.json())
      .then((response) => {
        this.fields.keywords.data.items = response.data;
      });
  },
};
</script>

<style scoped>
.form-container {
  width: 1000px;
  margin: auto;
  background-color: white;
  padding: 10px;
}
</style>
